// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var OS;
(function (OS) {
    OS["UNKNOWN"] = "UNKNOWN";
    OS["WINDOWS"] = "WINDOWS";
    OS["DARWIN"] = "DARWIN";
})(OS || (OS = {}));
export var OS_index;
(function (OS_index) {
    OS_index[OS_index["UNKNOWN"] = 0] = "UNKNOWN";
    OS_index[OS_index["WINDOWS"] = 1] = "WINDOWS";
    OS_index[OS_index["DARWIN"] = 2] = "DARWIN";
})(OS_index || (OS_index = {}));
export const Support = {
    ListOnPremIntegrations(fn, req) {
        return fn(`/syncapp/support/installer/integrations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    InstallSyncApp(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/support/installer/locations/${req["locationId"]}/sources`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UninstallSyncApp(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/support/installer/locations/${req["locationId"]}/sources/${req["sourceId"]}?${fm.renderURLSearchParams(req, ["locationId", "sourceId"])}`, { method: "DELETE" });
    },
    InstallerVersionCheck(fn, req) {
        return fn(`/syncapp/support/installer/version-check?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    InitiateDatapointEnrollment(fn, req) {
        return fn(`/syncapp/support/datapoint/initiate-enrollment`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListEnrolledDataSources(fn, req) {
        return fn(`/syncapp/support/enrolled-data-sources?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
